import { render, staticRenderFns } from "./MoblieSwitchs.vue?vue&type=template&id=0554a98f&scoped=true&"
import script from "./MoblieSwitchs.vue?vue&type=script&lang=js&"
export * from "./MoblieSwitchs.vue?vue&type=script&lang=js&"
import style0 from "./MoblieSwitchs.vue?vue&type=style&index=0&id=0554a98f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0554a98f",
  null
  
)

export default component.exports